export default __webpack_public_path__ + "static/media/bgMobile.b55d79ce.svg";